import React from 'react';
import { useRecoilValue } from 'recoil';
import {
  completedComponentIdsState,
  scenarioState,
} from '../stores/scenarioState';
import { formState, inputFormState } from '../stores/formState';
import {
  currentScenarioItemState,
  displayedScenarioItemState,
} from '../stores/displayedScenarioItemState';
import { skippedScenarioItemsState } from '../stores/skippedScenarioItemsState';

function json(obj: any): string {
  return JSON.stringify(obj, null, '\t');
}

function line(label: string, data: any) {
  return (<label><span>{label}</span><input type="checkbox"/><pre>{json(data)}</pre></label>)
}

const DebugInner = () => {
  const completedItemIds = useRecoilValue(completedComponentIdsState);
  const displayedScenarioItem = useRecoilValue(displayedScenarioItemState);
  const scenarioItems = useRecoilValue(scenarioState);
  const form = useRecoilValue(formState);
  // const completedFormIds = useRecoilValue(completedScenarioItemIdsState);
  const currentScenarioItem = useRecoilValue(currentScenarioItemState);
  const inputForm = useRecoilValue(inputFormState(currentScenarioItem?.id));
  const skippedItems = useRecoilValue(skippedScenarioItemsState);

  return (
    <>
      <style> {
        // language=css
        `
        #__debug {
          position: absolute;
          right: 0;
          bottom: 0;
          max-height: 100%;
          max-width: 480px;
          overflow: scroll;
          background-color: #282c34;
          color: aliceblue;
        }
        #__debug input {
          display: none;
        }
        #__debug span {
          color: #282c34;
          background-color: #61dafb;
          padding: 0.4em;
          display: inline-block;
          width: 100%;
          height: 1.8em;
          line-height: 1.8em;
        }
        #__debug pre {
          padding: 0;
          line-height: 1.5em;
          white-space: pre-wrap;
          height: 0;
          max-height: max-content;
          transition: height 0.1s linear;
          overflow: auto;
        }
        #__debug input:checked ~ pre {
          height: 240px;
          padding: 0.4em;
        }
      `}
      </style>
      <div id="__debug">
        {line('completedItemIds', completedItemIds)}
        {line('displayedScenarioItem', displayedScenarioItem)}
        {line('scenarioItems', scenarioItems)}
        {line('form', form)}
        {line('inputForm', inputForm)}
        {/*{line('completedFormIds', completedFormIds)}*/}
        {line('currentScenarioItem', currentScenarioItem)}
        {line('skippedScenarioItems', skippedItems)}
      </div>
    </>
  )
}

const Debug = () => {
  if (window.location.hostname !== 'localhost' || window.location.search.indexOf('debug=false') >= 0) return (<></>);
  return (<DebugInner/>)
}
export default Debug;
